var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var combineReducers = function (reducers) {
    var reducerKeys = Object.keys(reducers);
    var reducerValues = Object.values(reducers);
    var globalState = undefined;
    reducerKeys.forEach(function (key, index) {
        var _a;
        globalState = __assign(__assign({}, globalState), (_a = {}, _a[key] = reducerValues[index][1], _a));
    });
    var finalReducers = {};
    reducerValues.forEach(function (value, index) {
        var _a;
        finalReducers = __assign(__assign({}, finalReducers), (_a = {}, _a[reducerKeys[index]] = value[0], _a));
    });
    return [
        function (state, action) {
            var hasStateChanged = false;
            var newState = {};
            var nextStateForCurrentKey = {};
            for (var i = 0; i < reducerKeys.length; i++) {
                var currentKey = reducerKeys[i];
                var currentReducer = finalReducers[currentKey];
                var prevStateForCurrentKey = state[currentKey];
                nextStateForCurrentKey = currentReducer(prevStateForCurrentKey, action);
                hasStateChanged = hasStateChanged || nextStateForCurrentKey !== prevStateForCurrentKey;
                newState[currentKey] = nextStateForCurrentKey;
            }
            return hasStateChanged ? newState : state;
        },
        globalState,
    ];
};
//# sourceMappingURL=combine-reducers.js.map